import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthSimpleLayout from "../layouts/AuthSimpleLayout";
import ErrorLayout from "../layouts/ErrorLayout";
import MainLayout from "../layouts/MainLayout";

import Error404 from "components/errors/Error404";
import Error500 from "components/errors/Error500";

import SimpleForgetPassword from "components/authentication/simple/ForgetPassword";
import SimpleLogin from "components/authentication/simple/Login";
import SimplePasswordReset from "components/authentication/simple/PasswordReset";

import GroupsTable from "components/administration-menu/Groups/GroupsTable";
import AddGroup from "components/administration-menu/Groups/add-group/AddGroup";
import RolesAndPermissionsTable from "components/administration-menu/RolesAndPermissions/RolesAndPermissionsTable";
import AddAssignment from "components/administration-menu/RolesAndPermissions/add-assignment/AddAssignment";
import AddRoleAndPermission from "components/administration-menu/RolesAndPermissions/add-roleAndPermission/AddRoleAndPermission";
import UsersTable from "components/administration-menu/Users/UsersTable";
import AddUser from "components/administration-menu/Users/add-user/AddUser";
import Calendar from "components/calendar/Calendar";
import PatientsTable from "components/clinics-menu/Patients/PatientsTable";
import AddPatient from "components/clinics-menu/Patients/add-patient/AddPatient";
import AddAllergies from "components/clinics-menu/Patients/add-patient/allergies/add-allergies/AddAllergies";
import AddAppointment from "components/clinics-menu/Patients/add-patient/appointments/add-appointment/AddAppointment";
import AddMedicalProblem from "components/clinics-menu/Patients/add-patient/medical-problems/add-medical-problem/AddMedicalProblem";
import AddMedication from "components/clinics-menu/Patients/add-patient/medications/add-medication/AddMedication";
import AddVisit from "components/clinics-menu/Patients/add-patient/visits/add-visits/AddVisit";
import AddVital from "components/clinics-menu/Patients/add-patient/vitals/add-vital/AddVital";
import AppointmentsCalender from "components/clinics-menu/appointments/AppointmentsCalender";
import AgGridInfiniteScroll from "components/examples/AgGridInfiniteScroll/AgGridInfiniteScroll";
import GoogleMapExample from "components/examples/GoogleMapExample/GoogleMap";
import AddClinicContact from "components/libraries-menu/Clinics/Clinics-contacts/add-clinic-contact/AddClinicContact";
import ClinicsTable from "components/libraries-menu/Clinics/ClinicsTable";
import AddClinic from "components/libraries-menu/Clinics/add-clinic/AddClinic";
import RXTable from "components/libraries-menu/RX/RXTable";
import AddRX from "components/libraries-menu/RX/add-rx/AddRX";
import Profile from "components/pages/user/profile/Profile";
import Timeline from "components/timeline/Timeline";
import AuthGuard from "./Gaurd/AuthGaurd";
import AddLabReport from "components/clinics-menu/Patients/add-patient/lab-reports/add-lab-report/AddLabReport";
import TicketsTable from "modules/tickets/TicketsTable";
import AddTicket from "modules/tickets/add-ticket/AddTicket";
import TicketReport from "modules/reporting/tickets/TicketReport";
import ServicesTable from "components/libraries-menu/Services/ServicesTable";
import AddService from "components/libraries-menu/Services/add-service/AddService";
import FindTicket from "modules/tickets/view/FindTicket";

export const CONSTANT_ROUTES = {
  AUTHENTICATION_LOGIN: "/login",
  AUTHENTICATION_REGISTER: "/register",
  AUTHENTICATION_RESET_PASSWORD: "/reset-password",
  AUTHENTICATION_FORGOT_PASSWORD: "/forgot-password",
  USERPROFILE: "/userProfile",
  HOME: "/",
  CATEGORIES_TABLE: "",
  CATEGORY_ADD: "",
  MARKETS_TABLE: "/libraries/markets",
  ADD_NEW_MARKETS: "/libraries/markets/add-new",
  SPACE_ADDRESSES_TABLE: "/libraries/space-addresses",
  ADD_NEW_SPACE_ADDRESS: "/libraries/space-addresses/add-new",
  STATUES_TABLE: "/libraries/statuses",
  ADD_NEW_STATUS: "/libraries/statuses/add-new",
  MEDIUMS_TABLE: "/libraries/mediums",
  ADD_NEW_MEDIUM: "/libraries/mediums/add-new",
  VISIBILITY_TABLE: "/libraries/visibility",
  ADD_NEW_VISIBILITY: "/libraries/visibility/add-new",
  SPACE_CLASSES_TABLE: "/libraries/space-classes",
  ADD_NEW_SPACE_CLASS: "/libraries/space-classes/add-new",
  SPACE_SCORE_TABLE: "/libraries/space-score",
  ADD_NEW_SPACE_SCORE: "/libraries/space-score/add-new",
  VISIBILITY_ANGLES_TABLE: "/libraries/visibility-angles",
  ADD_NEW_VISIBILITY_ANGLES: "/libraries/visibility-angles/add-new",
  DISTANCES_TABLE: "/libraries/distances",
  ADD_NEW_DISTANCE: "/libraries/distances/add-new",
  DESIGN_TYPES: "/libraries/design-types",
  ADD_NEW_DESIGN_TYPE: "/libraries/design-types/add-new",
  MEDIUM_MATERIAL_TYPES_TABLE: "/libraries/material-types",
  ADD_NEW_MEDIUM_MATERIAL_TYPE: "/libraries/material-types/add-new",
  WORK_TYPES_TABLE: "/libraries/work-types",
  ADD_NEW_WORK_TYPE: "/libraries/work-types/add-new",
  PARTIES_TABLE: "/libraries/parties",
  ADD_NEW_PARTY: "/libraries/parties/add-new",
  ADD_NEW_PARTY_CONTACTS: "/libraries/parties/add-new/contact",
  INVENTORY_TABLE: "/ooh/inventory",
  ADD_NEW_INVENTORY: "/ooh/inventory/add-new",
  CITIES_TABLE: "/libraries/cities",
  ADD_NEW_CITY: "/libraries/cities/add-new",
  LOCATION_TABLE: "/libraries/locations",
  ADD_NEW_LOCATION: "/libraries/locations/add-new",
  LOCATION_ADDRESSES_TABLE: "/libraries/location-addresses",
  ADD_NEW_LOCATION_ADDRESS: "/libraries/location-addresses/add-new",
  SCHOOLS_TABLE: "/libraries/schools",
  ADD_NEW_SCHOOL: "/libraries/schools/add-new",
  HORECA_TABLE: "/libraries/horeca",
  ADD_NEW_HORECA: "/libraries/horeca/add-new",
  CONTACTS_TABLE: "/libraries/contacts",
  ADD_NEW_CONTACT: "/libraries/contacts/add-new",
  VENDORS_TABLE: "/libraries/vendors",
  ADD_NEW_VENDOR: "/libraries/vendors/add-new",
  ADD_NEW_VENDOR_CONTACT: "/libraries/vendors/add-new/contact",
  AGENCIES_TABLE: "/libraries/agencies",
  ADD_NEW_AGENCY: "/libraries/agencies/add-new",
  ADD_NEW_AGENCY_CONTACT: "/libraries/agencies/add-new/contact",
  CLIENTS_TABLE: "/libraries/clients",
  ADD_NEW_CLIENT: "/libraries/clients/add-new",
  ADD_NEW_CLIENT_CONTACT: "/libraries/clients/add-new/contact",
  PARTNERS_TABLE: "/libraries/partners",
  ADD_NEW_PARTNER: "/libraries/partners/add-new",
  ADD_NEW_PARTNER_CONTACT: "/libraries/partners/add-new/contact",
  AUTHORITIES_TABLE: "/libraries/authorities",
  ADD_NEW_AUTHORITY: "/libraries/authorities/add-new",
  ADD_NEW_AUTHORITY_CONTACT: "/libraries/authorities/add-new/contact",
  // =============================================================================
  CLINICS_TABLE: "/libraries/clinics",
  ADD_NEW_CLINIC: "/libraries/clinics/add-new",
  ADD_NEW_CLINIC_CONTACT: "/libraries/clinics/add-new/contact",

  RX_TABLE: "/libraries/rxs",
  ADD_NEW_RX: "/libraries/rxs/add-new",

  PATIENTS_TABLE: "/clinic/patients",
  ADD_NEW_PATIENT: "/clinic/patients/add-new",
  ADD_NEW_MEDICAL_PROBLEM: "/clinic/patients/add-new/medical-problem",
  ADD_NEW_ALLERGY: "/clinic/patients/add-new/allergy",
  ADD_NEW_MEDICATION: "/clinic/patients/add-new/medication",
  ADD_NEW_VISIT: "/clinic/patients/add-new/visit",
  ADD_NEW_LAB_REPORT: "/clinic/patients/add-new/lab-report",
  ADD_NEW_VITAL: "/clinic/patients/add-new/vital",
  ADD_NEW_APPOINTMENT: "/clinic/patients/add-new/appointment",

  APPOINTMENTS_CALENDER: "/clinic/appointments",

  TICKETS_TABLE: "/clinic/tickets",
  ADD_NEW_TICKET: "/clinic/tickets/add-new",

  SERVICES_TABLE: "/libraries/services",
  ADD_NEW_SERVICE: "/libraries/services/add-new",

  // ==============================Reports=============================

  TICKER_REPORT: "/ticket-report",
  FIND_TICKET: "/find-ticket",
};

const FalconRoutes = () => {
  return (
    <Routes>
      {/* <Route path="landing" element={<Landing />} /> */}
      <Route element={<ErrorLayout />}>
        <Route path="errors/404" element={<Error404 />} />
        <Route path="errors/500" element={<Error500 />} />
      </Route>
      {/*- ------------- Authentication ---------------------------  */}

      {/*- ------------- simple ---------------------------  */}
      <Route element={<AuthSimpleLayout />}>
        <Route
          path={CONSTANT_ROUTES.AUTHENTICATION_LOGIN}
          element={<SimpleLogin />}
        />
        {/* <Route
          path="authentication/register"
          element={<SimpleRegistration />}
        /> */}
        <Route
          path={CONSTANT_ROUTES.AUTHENTICATION_FORGOT_PASSWORD}
          element={<SimpleForgetPassword />}
        />

        <Route
          path={CONSTANT_ROUTES.AUTHENTICATION_RESET_PASSWORD}
          element={<SimplePasswordReset />}
        />
        {/* <Route
          path="authentication/lock-screen"
          element={<SimpleLockScreen />}
        />
        <Route path="authentication/logout" element={<SimpleLogout />} />
       
   
        <Route
          path="authentication/confirm-mail"
          element={<SimpleConfirmMail />}
        /> */}
      </Route>

      {/* //--- MainLayout Starts  */}

      <Route element={<AuthGuard />}>
        <Route element={<MainLayout />}>
          {/*Dashboard*/}
          {/* <Route path="/" element={<Dashboard />} /> */}
          <Route path="/" element={<AppointmentsCalender />} />

          {/* =============Libraries=============== */}
          {/* <Route path="/libraries/categories" element={<CategoriesTable />} />
          <Route
            path="/libraries/categories/add-new-category"
            element={<AddCategory />}
          />
          <Route path="/libraries/classes" element={<ClassesTable />} />
          <Route
            path="/libraries/classes/add-new-class"
            element={<AddClass />}
          />
          <Route path="/libraries/channels" element={<ChannelTable />} />
          <Route
            path="/libraries/channels/add-new-channel"
            element={<AddChannel />}
          />
          <Route path="/libraries/sizes" element={<SizesTable />} />
          <Route path="/libraries/sizes/add-new-size" element={<AddSize />} />
          <Route path="/libraries/uom" element={<UnitOfMeasurementTable />} />
          <Route path="/libraries/uom/add-new-unit" element={<AddUOM />} />
          <Route path="/libraries/places" element={<PlacesTable />} />
          <Route
            path="/libraries/places/add-new-place"
            element={<AddPlace />}
          />
          <Route path="/libraries/regions" element={<RegionsTable />} />
          <Route
            path="/libraries/regions/add-new-region"
            element={<AddRegion />}
          />
          <Route
            path={CONSTANT_ROUTES.CITIES_TABLE}
            element={<CitiesTable />}
          />
          <Route path={CONSTANT_ROUTES.ADD_NEW_CITY} element={<AddCity />} />
          <Route
            path={CONSTANT_ROUTES.LOCATION_TABLE}
            element={<LocationsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_LOCATION}
            element={<AddLocation />}
          />
          <Route
            path={CONSTANT_ROUTES.LOCATION_ADDRESSES_TABLE}
            element={<LocationsAddressesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_LOCATION_ADDRESS}
            element={<AddLocationAddress />}
          />
          <Route
            path={CONSTANT_ROUTES.SCHOOLS_TABLE}
            element={<SchoolsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_SCHOOL}
            element={<AddSchool />}
          />
          <Route
            path={CONSTANT_ROUTES.HORECA_TABLE}
            element={<HorecaTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_HORECA}
            element={<AddHoreca />}
          />
          <Route
            path="/libraries/authorities-rate-list"
            element={<AuthoritiesRateListTable />}
          />
          <Route
            path="/libraries/authorities-rate-list/add-new-authorities-rate-list"
            element={<AddAuthoritiesRateList />}
          />
          <Route
            path={CONSTANT_ROUTES.CONTACTS_TABLE}
            element={<ContactsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_CONTACT}
            element={<AddContact />}
          />
          <Route
            path={CONSTANT_ROUTES.AUTHORITIES_TABLE}
            element={<AuthoritiesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_AUTHORITY}
            element={<AddAuthority />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_AUTHORITY_CONTACT}
            element={<AddAuthorityContact />}
          />
          <Route path="/libraries/space-types" element={<SpaceTypesTable />} />
          <Route
            path="/libraries/space-types/add-new-space"
            element={<AddSpaceType />}
          />
          <Route
            path={CONSTANT_ROUTES.MARKETS_TABLE}
            element={<MarketsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_MARKETS}
            element={<AddMarket />}
          />
          <Route
            path={CONSTANT_ROUTES.SPACE_ADDRESSES_TABLE}
            element={<SpaceAddressesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_SPACE_ADDRESS}
            element={<AddSpaceAddress />}
          />
          <Route
            path={CONSTANT_ROUTES.STATUES_TABLE}
            element={<StatusesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_STATUS}
            element={<AddStatus />}
          />
          <Route
            path={CONSTANT_ROUTES.MEDIUMS_TABLE}
            element={<MediumsTableSecond />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_MEDIUM}
            element={<AddMediumSecond />}
          />
          <Route
            path={CONSTANT_ROUTES.VISIBILITY_TABLE}
            element={<VisibilityTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_VISIBILITY}
            element={<AddVisibility />}
          />
          <Route
            path={CONSTANT_ROUTES.SPACE_CLASSES_TABLE}
            element={<SpaceClassesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_SPACE_CLASS}
            element={<AddSpaceClass />}
          />
          <Route
            path={CONSTANT_ROUTES.SPACE_SCORE_TABLE}
            element={<SpaceScoreTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_SPACE_SCORE}
            element={<AddSpaceScore />}
          />
          <Route
            path={CONSTANT_ROUTES.VISIBILITY_ANGLES_TABLE}
            element={<VisibilityAnglesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_VISIBILITY_ANGLES}
            element={<AddVisibilityAngle />}
          />
          <Route
            path={CONSTANT_ROUTES.DISTANCES_TABLE}
            element={<DistancesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_DISTANCE}
            element={<AddDistance />}
          />
          <Route
            path={CONSTANT_ROUTES.DESIGN_TYPES}
            element={<DesignTypesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_DESIGN_TYPE}
            element={<AddDesignType />}
          />
          <Route
            path={CONSTANT_ROUTES.MEDIUM_MATERIAL_TYPES_TABLE}
            element={<MediumMaterialTypesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_MEDIUM_MATERIAL_TYPE}
            element={<AddMediumMaterialType />}
          />
          <Route
            path={CONSTANT_ROUTES.WORK_TYPES_TABLE}
            element={<WorkTypesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_WORK_TYPE}
            element={<AddWorkType />}
          /> */}
          {/* <Route
            path={CONSTANT_ROUTES.PARTIES_TABLE}
            element={<PartiesTable />}
          />
          <Route path={CONSTANT_ROUTES.ADD_NEW_PARTY} element={<AddParty />} />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_PARTY_CONTACTS}
            element={<AddPartyContact />}
          /> */}
          {/* <Route
            path={CONSTANT_ROUTES.INVENTORY_TABLE}
            element={<InventoryTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_INVENTORY}
            element={<AddInventory />}
          />

          <Route
            path={CONSTANT_ROUTES.VENDORS_TABLE}
            element={<VendorsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_VENDOR}
            element={<AddVendor />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_VENDOR_CONTACT}
            element={<AddVendorContact />}
          />
          <Route
            path={CONSTANT_ROUTES.AGENCIES_TABLE}
            element={<AgenciesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_AGENCY}
            element={<AddAgency />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_AGENCY_CONTACT}
            element={<AddAgencyContact />}
          />
          <Route
            path={CONSTANT_ROUTES.CLIENTS_TABLE}
            element={<ClientsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_CLIENT}
            element={<AddClient />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_CLIENT_CONTACT}
            element={<AddClientContact />}
          />
          <Route
            path={CONSTANT_ROUTES.PARTNERS_TABLE}
            element={<PartnersTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_PARTNER}
            element={<AddPartner />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_PARTNER_CONTACT}
            element={<AddPartnerContact />}
          />
          <Route path="/business-units" element={<BusinessUnitsTable />} />
          <Route
            path="/business-units/add-new-business-unit"
            element={<AddBusinessUnit />}
          />
          <Route path="/brand-groups" element={<BrandGroupsTable />} />
          <Route
            path="/brand-groups/add-new-brand-group"
            element={<AddBrandGroups />}
          />
          <Route path="/brans" element={<BransTable />} />
          <Route path="/brans/add-new-brans" element={<AddBrans />} />
          <Route path="/stores" element={<StoresTable />} />
          <Route path="/stores/add-new-store" element={<AddStore />} />
          <Route path="/sites" element={<SitesTable />} />
          <Route path="/sites/add-new-site" element={<AddSite />} />
          <Route path="/venues" element={<VenueTable />} />
          <Route path="/venues/add-new-venue" element={<AddVenue />} />
          <Route path="/mediums" element={<MediumsTable />} />
          <Route path="/mediums/add-new-medium" element={<AddMedium />} />
          <Route path="/drivers" element={<DriversTable />} />
          <Route path="/drivers/add-new-driver" element={<AddDriver />} />
          <Route path="/vehicles" element={<VehiclesTable />} />
          <Route path="/vehicles/add-new-vehicle" element={<AddVehicle />} /> */}
          {/* ===============Libraries End================ */}

          {/*============================Human Resource=========================  */}
          {/* <Route path="/promoters" element={<PromotersOrHRTable />} />
          <Route path="/promoters/add-new-promoter" element={<AddPromoter />} />
          <Route path="/attendances" element={<AttendancesTable />} />
          <Route
            path="/attendances/add-new-attendance"
            element={<AddAttendance />}
          /> */}
          {/*============================Human Resource End=========================  */}
          {/*============================Administration=========================  */}

          <Route path="/groups" element={<GroupsTable />} />
          <Route path="/groups/add-new-group" element={<AddGroup />} />
          <Route
            path="/administration/roles-and-permissions"
            element={<RolesAndPermissionsTable />}
          />
          <Route
            path="/administration/roles-and-permissions/add-new-role"
            element={<AddRoleAndPermission />}
          />
          <Route
            path="/administration/roles-and-permissions/assignment"
            element={<AddAssignment />}
          />
          <Route path="/administration/users" element={<UsersTable />} />
          <Route
            path="/administration/users/add-new-user"
            element={<AddUser />}
          />
          <Route path="/infinite-scroll" element={<AgGridInfiniteScroll />} />
          <Route path="/map" element={<GoogleMapExample />} />

          {/*============================Administration End=========================  */}

          {/*=======Pages  ======*/}

          <Route path={CONSTANT_ROUTES.USERPROFILE} element={<Profile />} />
          <Route path={"/calender"} element={<Calendar />} />
          <Route path={"/timeline"} element={<Timeline />} />

          {/* ====================================================================================== */}
          {/* ====================================================================================== */}
          {/* ====================================================================================== */}

          <Route
            path={CONSTANT_ROUTES.CLINICS_TABLE}
            element={<ClinicsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_CLINIC}
            element={<AddClinic />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_CLINIC_CONTACT}
            element={<AddClinicContact />}
          />

          <Route path={CONSTANT_ROUTES.RX_TABLE} element={<RXTable />} />
          <Route path={CONSTANT_ROUTES.ADD_NEW_RX} element={<AddRX />} />

          <Route
            path={CONSTANT_ROUTES.SERVICES_TABLE}
            element={<ServicesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_SERVICE}
            element={<AddService />}
          />

          <Route
            path={CONSTANT_ROUTES.PATIENTS_TABLE}
            element={<PatientsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_PATIENT}
            element={<AddPatient />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_MEDICAL_PROBLEM}
            element={<AddMedicalProblem />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_ALLERGY}
            element={<AddAllergies />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_MEDICATION}
            element={<AddMedication />}
          />
          <Route path={CONSTANT_ROUTES.ADD_NEW_VISIT} element={<AddVisit />} />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_LAB_REPORT}
            element={<AddLabReport />}
          />
          <Route path={CONSTANT_ROUTES.ADD_NEW_VITAL} element={<AddVital />} />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_APPOINTMENT}
            element={<AddAppointment />}
          />

          <Route
            path={CONSTANT_ROUTES.APPOINTMENTS_CALENDER}
            element={<AppointmentsCalender />}
          />

          <Route
            path={CONSTANT_ROUTES.TICKETS_TABLE}
            element={<TicketsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ADD_NEW_TICKET}
            element={<AddTicket />}
          />

          {/* =======================Reports============================ */}

          <Route
            path={CONSTANT_ROUTES.TICKER_REPORT}
            element={<TicketReport />}
          />

          {/* <Route path={"/pdf"} element={<PDFPreviewTableRow  />} /> */}
          {/* <Route path={"/tree-view"} element={<TreeViewComponent />} />
          <Route path={"/dynamic-form"} element={<DynamicForm />} /> */}
        </Route>
        <Route
          path={`${CONSTANT_ROUTES.FIND_TICKET}`}
          element={<FindTicket />}
        />
      </Route>

      {/* //--- MainLayout end  */}

      {/* <Navigate to="/errors/404" /> */}
      <Route path="*" element={<Navigate to="/errors/404" replace />} />
    </Routes>
  );
};

export default FalconRoutes;
